import React from "react";
import { Link } from "react-router-dom";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { X } from "lucide-react";

export default function LinkedItems({ label, items, options, onAdd, onRemove, disabled, testid, hrefOf }) {
  const avail = options.filter((o) => !items.some((i) => i.id === o.id));
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex flex-wrap gap-1.5">
        {items.map((i) => (
          <span key={i.id} className="inline-flex items-center gap-1.5 text-xs bg-slate-50 border border-slate-200 rounded-md px-2 py-1 max-w-full">
            <Link to={hrefOf(i)} className="truncate hover:text-indigo-600">{i.label}</Link>
            {!disabled && <button onClick={() => onRemove(i.id)} className="text-slate-400 hover:text-red-500 shrink-0" aria-label="Unlink" data-testid={`${testid}-remove-${i.id}`}><X className="w-3 h-3" /></button>}
          </span>
        ))}
        {!items.length && <span className="text-xs text-slate-400">None linked</span>}
      </div>
      {!disabled && (
        <Select value="" onValueChange={onAdd}>
          <SelectTrigger className="h-9" data-testid={`${testid}-add`}><SelectValue placeholder={`Link ${label}…`} /></SelectTrigger>
          <SelectContent>
            {avail.slice(0, 200).map((o) => <SelectItem key={o.id} value={o.id}>{o.label}</SelectItem>)}
            {!avail.length && <div className="px-2 py-1.5 text-xs text-slate-400">Nothing to link</div>}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
